var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 28.4166L31.5 36.1666L57.75 10.3333",
    stroke: "#F375AC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.125 31V49.0833C55.125 50.4536 54.5719 51.7678 53.5873 52.7367C52.6027 53.7057 51.2674 54.25 49.875 54.25H13.125C11.7326 54.25 10.3973 53.7057 9.41269 52.7367C8.42812 51.7678 7.875 50.4536 7.875 49.0833V12.9167C7.875 11.5464 8.42812 10.2322 9.41269 9.26328C10.3973 8.29434 11.7326 7.75 13.125 7.75H42",
    stroke: "#F375AC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.48f119bb6af68da58aadca497e8ba457.svg";
export { ForwardRef as ReactComponent };